import { pushAnalyticsEvent, truncateAnalyticsText } from '../../utils/analytics'

class Accordion {
  private static readonly faqQuestionMaxLength = 100

  private readonly accordions: NodeListOf<HTMLElement>

  constructor() {
    this.accordions = document.querySelectorAll<HTMLElement>('.accordion')

    if (this.accordions.length === 0) return

    this.accordions.forEach((accordion) => {
      this.setupAccordion(accordion)
    })
  }

  private setupAccordion(accordion: HTMLElement): void {
    const triggers = accordion.querySelectorAll<HTMLButtonElement>('.js-accordion-trigger')

    triggers.forEach((trigger) => {
      if (trigger.dataset.accordionBound === 'true') return

      trigger.dataset.accordionBound = 'true'

      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true'
        const expanded = !isExpanded
        this.setExpanded(trigger, expanded, accordion)

        if (expanded) {
          this.trackFaqExpand(trigger)
        }
      })
    })
  }

  private trackFaqExpand(trigger: HTMLButtonElement): void {
    const title = trigger.querySelector<HTMLElement>('.accordion-title')?.textContent

    if (title == null) return

    pushAnalyticsEvent({
      event: 'faq_expand',
      faq_question: truncateAnalyticsText(title, Accordion.faqQuestionMaxLength),
    })
  }

  private setExpanded(
    trigger: HTMLButtonElement,
    expanded: boolean,
    accordion?: HTMLElement
  ): void {
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false')

    const panel = this.getPanel(trigger, accordion)

    if (panel == null) return

    if (expanded) {
      panel.removeAttribute('hidden')
    } else {
      panel.setAttribute('hidden', '')
    }
  }

  private getPanel(trigger: HTMLButtonElement, accordion?: HTMLElement): HTMLElement | null {
    const panelId = trigger.getAttribute('aria-controls')

    if (panelId == null) return null

    const escapedPanelId = this.escapeCssIdentifier(panelId)
    const localPanel = accordion?.querySelector<HTMLElement>(`#${escapedPanelId}`)

    return localPanel ?? document.getElementById(panelId)
  }

  private escapeCssIdentifier(value: string): string {
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(value)
    }

    return value.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1')
  }
}

export default Accordion
